import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 810.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,810.000000) scale(0.100000,-0.100000)">
        <path d="M1770 4919 c-136 -22 -304 -100 -412 -190 -119 -100 -228 -272 -270
-426 -28 -103 -30 -314 -5 -418 25 -99 105 -258 171 -338 177 -213 474 -333
738 -299 206 27 362 103 508 251 81 81 104 111 146 196 134 263 133 524 -2
786 -40 79 -64 110 -148 194 -56 55 -127 115 -159 134 -168 99 -382 140 -567
110z m288 -352 c131 -130 133 -133 97 -129 -34 4 -41 -1 -150 -109 l-115 -113
-115 113 c-113 112 -115 114 -152 108 -37 -6 -35 -4 98 128 178 178 160 178
337 2z m237 -237 c10 -11 16 -20 13 -20 -3 0 -13 9 -23 20 -10 11 -16 20 -13
20 3 0 13 -9 23 -20z m76 -77 c13 -16 12 -17 -3 -4 -10 7 -18 15 -18 17 0 8 8
3 21 -13z m-1060 -220 c13 -16 12 -17 -3 -4 -17 13 -22 21 -14 21 2 0 10 -8
17 -17z m1069 -96 c0 -2 -10 -12 -22 -23 l-23 -19 19 23 c18 21 26 27 26 19z
m-418 -54 c49 -43 74 -74 70 -86 -1 -5 1 -6 6 -3 14 8 65 -51 57 -65 -5 -8 -4
-10 3 -5 8 5 12 -3 12 -26 0 -28 -14 -46 -92 -125 -124 -126 -129 -126 -255 0
-81 81 -93 98 -93 127 0 29 12 46 93 127 111 111 131 116 199 56z"/>
<path d="M8550 4135 l0 -375 44 0 44 0 4 178 c4 198 10 219 75 269 30 23 48
28 107 31 57 2 77 -1 103 -17 59 -37 66 -65 71 -273 l4 -188 44 0 44 0 0 196
c0 176 -2 200 -21 244 -36 83 -105 122 -216 121 -79 0 -148 -23 -190 -63 l-23
-21 0 136 0 137 -45 0 -45 0 0 -375z"/>
<path d="M5585 4468 c-2 -7 -12 -88 -22 -179 l-19 -166 145 -6 c171 -7 213
-17 258 -62 28 -28 33 -40 33 -83 0 -106 -76 -156 -225 -148 -94 5 -139 17
-190 51 l-36 25 -19 -22 c-11 -13 -19 -26 -20 -31 0 -15 93 -66 141 -76 196
-42 349 -6 406 96 63 113 22 230 -99 284 -44 19 -76 23 -180 27 -98 3 -128 7
-128 18 0 16 19 160 26 192 4 22 6 22 184 22 l180 0 0 35 0 35 -215 0 c-164 0
-217 -3 -220 -12z"/>
<path d="M6377 4469 c-75 -18 -145 -59 -200 -119 -68 -73 -92 -135 -91 -240 0
-134 70 -243 197 -305 142 -69 311 -70 447 -2 l65 32 3 143 3 142 -40 0 -40 0
-3 -127 -3 -128 -65 -23 c-54 -19 -80 -22 -156 -19 -146 6 -244 62 -297 171
-53 108 -31 241 54 325 68 69 194 108 304 96 61 -6 175 -51 189 -74 5 -7 16
-2 33 13 14 13 22 29 19 35 -13 20 -95 63 -148 77 -58 15 -211 17 -271 3z"/>
<path d="M3296 4308 c-116 -242 -204 -424 -235 -486 l-31 -62 59 0 59 0 38 85
38 85 182 0 181 0 39 -85 39 -85 63 0 c35 0 61 3 59 8 -2 4 -75 157 -163 340
l-158 332 -54 0 -53 0 -63 -132z m241 -284 c-2 -3 -63 -3 -135 -2 l-131 3 67
143 67 143 68 -141 c38 -78 66 -144 64 -146z"/>
<path d="M6935 4339 c-52 -50 -95 -95 -95 -100 0 -5 25 -9 55 -9 l55 0 0 -160
c0 -166 8 -209 48 -254 32 -35 93 -56 170 -56 l72 0 0 40 0 40 -56 0 c-60 0
-90 11 -116 44 -15 18 -18 45 -18 184 l0 162 95 0 95 0 0 40 0 40 -95 0 -95 0
0 60 c0 33 -4 60 -10 60 -5 0 -52 -41 -105 -91z"/>
<path d="M8133 4320 c-103 -15 -197 -82 -236 -169 -29 -64 -29 -170 -1 -231
30 -63 97 -126 162 -150 61 -23 174 -28 239 -11 59 16 132 69 164 120 39 61
38 71 -12 71 -37 0 -48 -6 -88 -48 -113 -117 -306 -90 -372 53 -47 101 5 224
113 269 88 37 217 5 273 -68 24 -32 33 -36 71 -36 27 0 44 5 44 12 0 6 -14 33
-31 59 -38 60 -123 116 -188 124 -25 3 -55 7 -66 9 -11 2 -43 0 -72 -4z"/>
<path d="M7426 4306 c-87 -32 -168 -124 -186 -212 -24 -113 24 -228 119 -292
63 -41 113 -55 196 -54 79 1 143 20 192 58 34 26 93 99 93 116 0 4 -22 8 -49
8 -41 0 -51 -4 -65 -25 -37 -57 -171 -91 -252 -65 -72 23 -117 68 -138 138
l-7 22 265 0 266 0 0 38 c0 103 -63 205 -156 252 -40 21 -66 25 -144 27 -63 2
-108 -2 -134 -11z m205 -77 c54 -18 129 -99 129 -139 0 -6 -70 -10 -210 -10
-231 0 -227 -1 -195 60 16 31 66 73 105 89 34 13 130 13 171 0z"/>
<path d="M3905 4255 c-5 -2 -27 -6 -47 -10 l-38 -6 0 -344 0 -345 55 0 55 0 0
105 0 106 53 -8 c235 -35 397 68 397 254 0 75 -19 125 -63 171 -88 92 -241
108 -349 36 l-38 -24 0 35 c0 34 -3 37 -25 30z m294 -115 c63 -44 83 -174 38
-241 -44 -67 -151 -89 -256 -54 l-51 17 0 126 0 127 34 23 c64 44 176 45 235
2z"/>
<path d="M4587 4243 c-177 -59 -245 -279 -126 -408 107 -116 337 -124 475 -16
l21 17 -22 26 -22 26 -58 -29 c-49 -24 -70 -29 -133 -29 -116 0 -178 38 -202
121 l-9 29 219 0 219 0 7 34 c12 69 -14 136 -76 189 -67 57 -191 74 -293 40z
m204 -80 c29 -17 48 -44 60 -85 l8 -28 -170 0 -170 0 6 23 c8 25 51 74 80 90
51 28 137 28 186 0z"/>
<path d="M4952 4241 c2 -5 50 -59 107 -121 l103 -110 -88 -96 c-49 -52 -100
-108 -113 -125 l-24 -29 64 0 64 0 79 91 80 92 85 -92 86 -92 63 1 c34 0 62 3
62 6 0 4 -49 59 -110 124 l-109 117 109 119 109 119 -62 3 c-57 3 -64 1 -87
-25 -14 -16 -49 -56 -77 -88 l-53 -60 -81 88 -81 87 -65 0 c-35 0 -63 -4 -61
-9z"/>
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
